import { applicationAccessOptions } from 'utils/consts/securityOptions'

export default function applicationAccess(value: string): string {
    return applicationAccessOptions.find((i) => i.value === value)?.name ?? ''
}
